import axios from 'axios';

const DOC_DOWNLOAD_FORM_URL =
  typeof window !== 'undefined'
    ? window.starlingbank.getConfig('documentDownloadFormUrl')
    : 'https://api-gw.jn3cx6xo36.net/downloads';

const NON_CUSTOMER_DOWNLOAD_URL =
  typeof window !== 'undefined'
    ? window.starlingbank.getConfig('nonCustomerDocumentDownloadFormUrl')
    : 'https://prod-referrals.jn3cx6xo36.net/referrals-public-api/api/v1/document-share/download';

export const submitDocumentDownload = (data) => {
  if (Object.hasOwn(data, 'documentHash')) {
    let filename = '';
    return fetch(NON_CUSTOMER_DOWNLOAD_URL, {
      method: 'PUT',
      headers: {
        Accept: 'application/octet-stream',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then((response) => {
        // Header value is in the format of `attachment; filename="<FILENAME>"`
        const contentDisposition = response.headers.get('Content-Disposition');
        const regex = /filename="([^"]*)"/;
        const match = contentDisposition.match(regex);
        filename = match ? match[1] : '';

        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const el = document.createElement('a');

        if (url) {
          el.download = filename;
          el.href = url;
          el.click();
        }
      });
  } else {
    return axios({
      url: DOC_DOWNLOAD_FORM_URL,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      data
    }).then((res) => {
      const uri = res?.data?.preSignedUrl;

      if (uri) {
        const link = document.createElement('a');
        link.download = '';
        link.href = uri;
        link.click();
      }
    });
  }
};
